// extracted by mini-css-extract-plugin
export default {"restoreYourDataContainer":"styles_restoreYourDataContainer__9wboV","restoreYourDataInner":"styles_restoreYourDataInner__9Pjbq"};